import { Box, Divider, Paper } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { styled } from '@material-ui/styles';
import { Linked } from '@type-r/react';
import * as React from 'react';
import { ReactNode } from 'react';
import { div, getQueryParam } from '../common';
import { Flex } from '../flex';
import { Link } from '../link';
import { ColorBar, TileLabel } from './tilesList';

const HeaderTileTitle = styled('div')({
    marginTop: 4,
    marginBottom: 4,
    color: '#000',
    fontFamily: 'Montserrat',
    fontSize: 22,
    fontWeight: 500,
});

export const PageTileField = ({ label, children, $checked } : {
    label : ReactNode
    children: ReactNode
    $checked? : Linked<boolean>
}) =>
    <PageTileFieldRoot
        className={ $checked ? (
            'selection' + ( $checked.value ? ' checked' : '' )
        ): ''}
        onClick={ $checked && $checked.true }
    >
        <TileLabel> {label} </TileLabel>
        <PageTileValue> {children} </PageTileValue>
    </PageTileFieldRoot>

const PageTileFieldRoot = div({
    display: 'flex',
    flexDirection: 'column',
    minWidth: 100,
    padding: 4,
    margin : 4,
    borderWidth: 1,
    borderRadius: 3,

    '&.selection' : {
        cursor : 'pointer',

        '&.checked' : {
            backgroundColor: '#fff8e5',
            borderStyle: 'solid',
            borderColor: 'rgb(255, 188, 0)',
        }
    }
});

const PageTileValue = styled( 'div' )({
    color: '#000',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: 500,
});

export const PageHeaderTile = ({ color = null, noPaper = false, right = undefined, children, title = null, toolbar = null, returnLink = null }) => {
    const returnUrl = getQueryParam('returnUrl');
    
    return (
        <MaybePaper noPaper={noPaper}>
            <Box display="flex" flexDirection="row" p={2} pb={1}>
                { color ? <ColorBar color={ color } /> : null }
                <Box ml={1} display="flex" flexDirection="column">
                    { title &&
                        <HeaderTileTitle>
                            { returnLink &&
                                <PageReturnLink><Link href={returnUrl || returnLink}><ArrowBackIcon /> Back</Link></PageReturnLink>
                            }
                            { title }
                        </HeaderTileTitle>
                    }
                    <Flex row wrap>
                        { children }
                    </Flex>
                </Box>

                { right ? <>
                    <Flex grow />
                    <Flex center>
                        { right }
                    </Flex>
                </> : null }
            </Box>
            { toolbar ? <>
                <Divider/>
                { toolbar }
            </> : null}
            
        </MaybePaper>
    )
}

const MaybePaper = ({ noPaper, children }) =>
    noPaper ? children : <Paper>{children}</Paper>

const PageReturnLink = styled( 'div' )({
    color: '#000',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 4,
});
    